const styles = { 
  submitButton: { 
    margin: '10px' 
  }
};

export default styles;